module.exports = __webpack_public_path__ + "static/media/2026_WA-Footy-Lives-Here-Social.3da70e0a.jpg";